export const getWaitingForWorkEnabled = (state) => {
  return state?.companySettings?.enableWaitingForWork ?? false;
};
